// extracted by mini-css-extract-plugin
export default {"mn-card-reject-comment-windows-show":"index_mn-card-reject-comment-windows-show__YCe0i"};